














































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { MapStoreModule } from "@/store/modules/mapStore";
import GoogleMap from "vue2-google-maps/src/components/map.vue";
import GmapCluster from "vue2-google-maps/src/components/cluster.js";
import GmapMarker from "vue2-google-maps/src/components/marker.js";
import StorePopUp from "@/components/StorePopUp.vue";
import {centralCoast, centralValley, GMapsStyle} from "@/utils/helpers.ts";
import { config } from "@/utils/config/config.ts";
import closable from "@/closable-directive.ts";

interface CenterType {
  lat: number;
  lng: number;
}

interface MarksType {
  id: number;
  position: CenterType;
  type: string;
}
@Component({
  components: {
    GoogleMap,
    GmapCluster,
    GmapMarker,
    StorePopUp
  },
  directives: {
    closable
  }
})
export default class GoogleMapWrap extends Vue {
  @Prop() marks!: Array<object>;
  @Prop() center!: { lat: number; lng: number };
  private position = { lat: 0, lng: 0 };
  private numDeltas = 9;
  private delay = 50;
  private refresh = 0;
  private deltaLat = 0;
  private deltaLng = 0;
  private activeWindow: any;
  private popupEnabled: any;
  private tempPinNumberLat = 0;
  private visiblePinArea = 0.33;
  private icons = {
    default: config.appImgUrl + "images/map_pin_def.png",
    active: config.appImgUrl + "images/map_pin.png"
  };
  private simpleMarks: MarksType[] = [];
  private configs: any;
  private gmapStyle = GMapsStyle;
  private mapZoom = 14;
  private visibleClusters = false;
  private debugInfo = false;
  private labelMarkers = centralCoast;
  private demoMode = process.env.NODE_ENV === "development";

  get altitudeZoom() {
    return this.mapZoom;
  }

  get mapZooming(): any {
    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    if (this.$refs.map && this.$refs.map.$mapObject) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      // @ts-ignore
      // console.log(this.$refs.map.$mapObject.getZoom());
      // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      // @ts-ignore
      return this.$refs.map.$mapObject.getZoom();
    }
    return this.mapZoom;
  }

  get availableStores() {
    return MapStoreModule.stores;
  }

  get existStores(): boolean {
    return MapStoreModule.isActiveStatus;
  }

  get isPinCluster(): boolean {
    if (
      !this.configs["map-pin-cluster"] ||
      this.configs["map-pin-cluster"] == ""
    ) {
      return MapStoreModule.bookmarks;
    }
    return true;
  }

  get isOptimizedPin(): boolean {
    if (
      !this.configs["map-pin-optimized"] ||
      this.configs["map-pin-optimized"] == ""
    ) {
      return false;
    }
    return true;
  }

  private isMarkAvailable(markValue: number) {
    return markValue;
  }

  get centerMark() {
    return MapStoreModule.center;
  }

  get isPopUp(): boolean {
    return MapStoreModule.activePopUp && MapStoreModule.isGalleryCollection;
  }

  protected created(): void {
    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    if (this.$refs.map && this.$refs.map.$mapObject.getZoom() <= 14) {
      this.visibleClusters = false;
      return;
    }
    this.visibleClusters = this.isPinCluster;
  }

  private beforeCreate() {
    this.popupEnabled = true;
    this.configs = Vue.prototype.$globalConfig;
    if (!this.configs["popup-window"] || this.configs["popup-window"] == "") {
      this.popupEnabled = false;
    }
  }

  private onClosePopUp() {
    MapStoreModule.togglePopUp(false);
  }

  private resetZoom(): void {
    if (this.visibleClusters) {
      this.mapZoom = 16;
      // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      // @ts-ignore
      const map = this.$refs.map?.$mapObject;
      if (map) {
        this.clickPosition();
        this.transition();
        this.visibleClusters = false;
        map.setZoom(16);
      }
    }
  }

  private setActivePin(id: number): void {
    const myElement = document.getElementById("list-" + id);
    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    const topPos = myElement.offsetTop;
    setTimeout(() => {
      document
        .getElementsByClassName("distrib-view")[0]
        .scrollTo({ top: topPos - 130, behavior: "smooth" });
      MapStoreModule.changeStore(id);
      MapStoreModule.togglePopUp(false);
    }, 100);
  }

  // @Watch("mapZooming")
  // omMapZooming() {
  //   if (!this.visibleClusters && this.isPinCluster && this.mapZooming <= 14) {
  //     this.visibleClusters = true;
  //   }
  // }

  @Watch("position")
  onPosition() {
    if (!this.isOptimizedPin) {
      this.simpleMarks = MapStoreModule.marks;
      return;
    }

    if (this.position.lat === 0 && this.position.lng === 0) {
      return;
    }
    const tempPositionLat =
      this.position.lat < 0 ? this.position.lat * -1 : this.position.lat;
    const tempPositionLng =
      this.position.lng < 0 ? this.position.lng * -1 : this.position.lng;

    if (
      this.tempPinNumberLat === 0 ||
      this.calcLatDifference(tempPositionLat)
    ) {
      this.tempPinNumberLat = tempPositionLat;
    }
    if (tempPositionLat != this.tempPinNumberLat) {
      return;
    }

    this.simpleMarks = [];
    MapStoreModule.marks.forEach((value, i) => {
      const tempMarkLat =
        value.position.lat < 0 ? value.position.lat * -1 : value.position.lat;
      const tempMarkLng =
        value.position.lng < 0 ? value.position.lng * -1 : value.position.lng;

      if (
        this.calcBetweenPositions(tempPositionLat, tempMarkLat) <=
          this.visiblePinArea &&
        this.calcBetweenPositions(tempPositionLng, tempMarkLng) <=
          this.visiblePinArea &&
        (this.calcBetweenPositions(tempPositionLat, tempMarkLat) >= 0 ||
          this.calcBetweenPositions(tempPositionLng, tempMarkLng) >= 0)
      ) {
        this.simpleMarks.push(value);
        return;
      }
      if (
        this.calcBetweenPositions(
          tempPositionLat + this.visiblePinArea,
          tempMarkLat
        ) <= this.visiblePinArea &&
        this.calcBetweenPositions(
          tempPositionLng + this.visiblePinArea,
          tempMarkLng
        ) <= this.visiblePinArea &&
        (this.calcBetweenPositions(
          tempPositionLat + this.visiblePinArea,
          tempMarkLat
        ) >= 0 ||
          this.calcBetweenPositions(
            tempPositionLng + this.visiblePinArea,
            tempMarkLng
          ) >= 0)
      ) {
        this.simpleMarks.push(value);
      }
    });
  }

  // @Watch("mapZoom")
  // onMapZoom() {
  //   // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
  //   // @ts-ignore
  //   if (this.$refs.map && this.$refs.map.$mapObject.getZoom() <= 14) {
  //     this.visibleClusters = false;
  //     return;
  //   }
  //   this.visibleClusters = this.isPinCluster;
  // }

  @Watch("centerMark")
  onCenterMark() {
    const bookmarkPlaces: string[] = ["94501", "95811", "92014", "95667", "95201", "93940", "95201", "95003"];
    let zipListOrder = "0";
    let bayareaLocations = false;
    let sacramentoLocation = false;
    let northLocation = false;
    let sierraLocation = false;
    let northernsanLocation = false;
    let montereyLocation = false;
    let centralValleyLocation = false;
    let centralCoastLocation = false;

    // Bay Area
    if (MapStoreModule.activeZip === bookmarkPlaces[0] && MapStoreModule.bookmarks) {
      bayareaLocations = true;
      zipListOrder = MapStoreModule.activeZip;
    }
    if (bayareaLocations && MapStoreModule.firstEntry) {
      this.position = { lat: 38.36379315351717, lng: -122.39115767284055 };
      this.mapZoom = 8;
      MapStoreModule.tooggleEntry(false);
      return;
    }

    //Sacramento Area
    if (MapStoreModule.activeZip === bookmarkPlaces[1] && MapStoreModule.bookmarks) {
      sacramentoLocation = true;
      zipListOrder = MapStoreModule.activeZip;
    }
    if (sacramentoLocation && MapStoreModule.firstEntry) {
      this.position = { lat: 39.230000727396906, lng: -121.4922702546875};
      this.mapZoom = 8;
      MapStoreModule.tooggleEntry(false);
      return;
    }

    // North Area
    if (MapStoreModule.activeZip === bookmarkPlaces[2] && MapStoreModule.bookmarks) {
      northLocation = true;
      zipListOrder = MapStoreModule.activeZip;
    }
    if (northLocation && MapStoreModule.firstEntry) {
      this.position = { lat: 33.186400312766985, lng: -116.99128380508421 };
      this.mapZoom = 10;
      MapStoreModule.tooggleEntry(false);
      return;
    }

    //Sierra
    if (MapStoreModule.activeZip === bookmarkPlaces[3] && MapStoreModule.bookmarks) {
      sierraLocation = true;
      zipListOrder = MapStoreModule.activeZip;
    }
    if (sierraLocation && MapStoreModule.firstEntry) {
      this.position = { lat: 37.5211271492669, lng: -121.8079019125 };
      this.mapZoom = 6;
      MapStoreModule.tooggleEntry(false);
      return;
    }

    //Northern San
    if (MapStoreModule.activeZip === bookmarkPlaces[4] && MapStoreModule.bookmarks) {
      northernsanLocation = true;
      zipListOrder = MapStoreModule.activeZip;
    }
    if (northernsanLocation && MapStoreModule.firstEntry) {
      this.position = { lat: 38.04392718225195, lng: -120.92389511400145};
      this.mapZoom = 10;
      MapStoreModule.tooggleEntry(false);
      return;
    }

    //Monterey
    if (MapStoreModule.activeZip === bookmarkPlaces[5] && MapStoreModule.bookmarks) {
      montereyLocation = true;
      zipListOrder = MapStoreModule.activeZip;
    }
    if (montereyLocation && MapStoreModule.firstEntry) {
      this.position = { lat: 36.33883814178881, lng: -121.40760322347413 };
      this.mapZoom = 8;
      MapStoreModule.tooggleEntry(false);
      return;
    }

    //Central Valley
    if (MapStoreModule.activeZip === bookmarkPlaces[6] && MapStoreModule.bookmarks) {
      centralValleyLocation = true;
      zipListOrder = MapStoreModule.activeZip;
    }
    if (centralValleyLocation && MapStoreModule.firstEntry) {
      this.position = { lat: 37.76658637932023, lng: -122.43129846033379 };
      this.mapZoom = 8;
      MapStoreModule.tooggleEntry(false);
      return;
    }

    //Central Coast
    if (MapStoreModule.activeZip === bookmarkPlaces[7] && MapStoreModule.bookmarks) {
      centralCoastLocation = true;
      zipListOrder = MapStoreModule.activeZip;
    }
    if (centralCoastLocation && MapStoreModule.firstEntry) {
      this.position = { lat: 36.066185054095, lng:  -120.9496826171875 };
      this.mapZoom = 7;
      MapStoreModule.tooggleEntry(false);
      return;
    }

    if (zipListOrder === "0" || !MapStoreModule.firstEntry) {
      this.mapZoom = 14;
    }

    if (this.position.lat === 0 && this.position.lng === 0) {
      this.position = this.centerMark;
      return;
    }
    if (this.refresh > 0 && this.refresh != this.numDeltas) {
      return;
    }
    this.refresh = 0;
    this.transition();
  }

  private clickPosition() {
    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    if (this.$refs.map.$mapObject && this.$refs.map.$mapObject.getCenter()) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      // @ts-ignore
      this.position = this.$refs.map.$mapObject.getCenter().toJSON();
      //console.log('position map:', this.position);
    }
    return;
  }

  private transition(): void {
    this.deltaLat = (this.centerMark.lat - this.position.lat) / this.numDeltas;
    this.deltaLng = (this.centerMark.lng - this.position.lng) / this.numDeltas;
    this.movingTo();
    return;
  }

  private movingTo(): any {
    if (this.refresh != this.numDeltas) {
      this.wait(this.delay).then(() => {
        this.refresh++;
        this.position.lat += this.deltaLat;
        this.position.lng += this.deltaLng;
        if (this.activeWindow) {
          clearTimeout(this.activeWindow);
        }
        this.movingTo();
      });
    }
    if (this.refresh === this.numDeltas) {
      this.activeWindow = setTimeout(() => {
        MapStoreModule.togglePopUp(true);
      }, 100);
      return;
    }
    return;
  }
  private wait(t): any {
    return new Promise(function(resolve) {
      window.setTimeout(resolve, t);
    });
  }

  private calcLatDifference(tempPositionLat: number): boolean {
    let difference = 0;

    if (tempPositionLat > this.tempPinNumberLat) {
      difference = tempPositionLat - this.tempPinNumberLat;
      if (difference >= this.visiblePinArea / 4) {
        return true;
      }
    }

    if (tempPositionLat < this.tempPinNumberLat) {
      difference = this.tempPinNumberLat - tempPositionLat;
      if (difference >= this.visiblePinArea / 4) {
        return true;
      }
    }

    return false;
  }

  private calcBetweenPositions(number1: number, number2: number) {
    if (number1 > number2) {
      return number1 - number2;
    }
    return number2 - number1;
  }
}
